import Reflux from 'reflux';

import actions from '../actions';
import configurationStore from './configuration-store';
import stateStore from './state-store';

import baseFacetStore from './base-facet-store';

export default Reflux.createStore(
	Object.assign({}, baseFacetStore, {
		init() {
			this.listenTo(configurationStore, this.onConfigurationChange);
			this.listenTo(stateStore, this.onStateChange);

			this.state = {
				facets: [],
				userSelection: {},
				filteredFacets: [],
				preselectionItemCounts: {},
				configuration: {
					facetRequirements: {},
					preselection: {},
					reducedFacets: [],
					visibleFacets: []
				}
			};
		},

		onLoadFacetsCompleted(facets) {
			facets = this.state.configuration.visibleFacets.map(facetId => facets.find(facet => facet.id === facetId));
			facets = this._mapFacets(facets);

			const requirements = this.state.configuration.facetRequirements || {};
			if (requirements) {
				facets = this._applyFacetRequirements(facets, requirements);
			}

			this.state.facets = facets;
			actions.facetsLoaded();
			this.output();
		},

		onSelectPropertyById(facetId, propertyId) {
			const facet = this.state.facets.find(possibleFacet => possibleFacet.id === facetId);
			if (!facet || !facet.properties) {
				// init wizard if no facet found
				actions.initializeWizards();
				return;
			}

			const property = facet.properties.find(possibleProperty => possibleProperty.id === propertyId);
			if (!property) {
				// init wizard if no property found
				actions.initializeWizards();
				return;
			}

			actions.selectProperty(facet, property);
			actions.selectModel();
		}
	})
);
